import React, { useEffect, useRef, useState } from "react";
import useWebSocket from "react-use-websocket";
import { Box, Typography, Paper } from "@mui/material";
import { green, orange, red, grey } from "@mui/material/colors";
import logger from "../utils/logger";
import DataGridWebSocketService from "../api/services/data-grid-websocket-service";




const WebSocketConnectionStatusIndicator = () => {
  const [readyState, setReadyState] = useState<number>(WebSocket.CONNECTING);
  const previousState = useRef<number>(WebSocket.CONNECTING);

  useEffect(() => {
    const interval = setInterval(() => {
      const socket = DataGridWebSocketService.getSocket();
      if (!socket) return;
      if (socket.readyState !== previousState.current) {
        const stateMap: { [key: number]: string } = {
          0: "Connecting",
          1: "Connected",
          2: "Closing",
          3: "Closed",
        };

        logger.info(
          `WebSocket state changed: ${stateMap[previousState.current]} → ${stateMap[socket.readyState]}`
        );

        previousState.current = socket.readyState;
        setReadyState(socket.readyState);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const getStatusText = () => {
    switch (readyState) {
      case WebSocket.CONNECTING:
        return { text: "Connecting", color: orange[500] };
      case WebSocket.OPEN:
        return { text: "Connected", color: green[500] };
      case WebSocket.CLOSING:
      case WebSocket.CLOSED:
        return { text: "Offline", color: red[500] };
      default:
        return { text: "Unknown", color: grey[500] };
    }
  };

  const status = getStatusText();

  return (
    <Paper
      className="w-32"
      elevation={3}
      sx={{
        bottom: 0,
        left: 0,
        right: 0,
        padding: 0.5,
        borderRadius: "10px",
        fontWeight: "bold",
        backgroundColor: "#5D8AD8",
        textAlign: "center",
        cursor: readyState === WebSocket.CLOSED ? "pointer" : "default",
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="center">
        <Box
          sx={{
            width: 16,
            height: 16,
            borderRadius: "50%",
            backgroundColor: status.color,
            marginRight: 1,
            boxShadow: `0 0 10px 3px ${status.color}`,
          }}
        />
        <Typography variant="body2" color="white">
          {status.text}
        </Typography>
      </Box>
    </Paper>
  );
};

export default WebSocketConnectionStatusIndicator;


